import React from "react";
import { FaArrowLeft, FaArrowRight, FaArrowUp } from "react-icons/fa";
import "./ManagedCybersecurity.css";
import Button from "../../components/Button/Button";
import { Container, Row, Col, Card } from "react-bootstrap";
import OfferingsTabs from "../../components/OfferingsTabs/OfferingsTabs";
import "bootstrap/dist/css/bootstrap.min.css";
import GetInTouch from "../../components/GetInTouch/GetInTouch";
import datamig from "../../assets/images/datamig.png";
import infra from "../../assets/images/infra.png";
import totalsystem from "../../assets/images/totalsystem.png";
import { Helmet } from "react-helmet";

const cyberStories = [
  {
    id: 1,
    image: infra,
    title:
      "Optimizing Data Management and Scalability with AWS Redshift",
    link: "/resources/case-studies/Redshift-Migration-for-Loan-Origination-System.pdf",
  },
  {
    id: 2,
    image: totalsystem,
    title:
      "Optimizing Data Migration to AWS: A Seamless Transition",
    link: "resources/case-studies/Public-ClickStream-Case-Study.pdf",
  },
  {
    id: 3,
    image: datamig,
    title: "Modernizing a Legacy ERP System Through Cloud Migration",
    link: "/resources/case-studies/on-premises-to-cloud-migration-for-leading-erp-solutions-providers.pdf",
  },
];

const ManagedCybersecurity = () => {
  return (
    <div className="managed-cybersecurity-page">
         <Helmet>
        <title>Managed Cybersecurity Services and Solutions | Idexcel</title>
        <meta
          name="description"
          content="Protect your business with expert-managed cybersecurity services and solutions. Detect, prevent, and respond to threats with cutting-edge security. Secure your organization today!"
        />
      </Helmet>
      {/* //banner section  */}
      <section className="cyber-banner-section">
        <Container className="mt-5">
          <Row>
            <Col lg={12}>
              <div className="cyber-banner-overlay mt-5">
                <h1 className="banner-title">
                  Fortify Your Digital Assets Against Advanced Threats
                </h1>
                <Button className="banner-button" size="large" color="banner">
                  <a href="/contact-us" className="text-white">
                    Contact Us
                  </a>
                  <FaArrowUp className="explore-arrow" />
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* section 2 */}

      <section className="centered-section">
        <Container>
          <h2 className="section-heading">
            Are Cyber Threats Outpacing Your <br />
            Security Measures?
          </h2>
          <p className="section-paragraph" style={{ textAlign: "left" }}>
            Defend against evolving cyber threats with AI-powered security
            frameworks that detect anomalies and predict attacks at every layer.
            Prevent breaches, financial losses, and disruptions with Zero Trust
            architecture. Implement SOC2, ISO 27000, and NIST SP 800-53
            frameworks to fortify security and maintain digital trust.
          </p>
        </Container>
      </section>

      <OfferingsTabs />

      {/* section 2 */}

      {/* <section className="cyber-customer-stories mt-5">
        <Container>
          <h2 className="section-title">Customer Success Stories</h2>
          <div className="cyber-stories-grid">
            {cyberStories.map((story) => (
              <div key={story.id} className="story-card image-hover-zoom ">
                <div className="image-hover-zoom" style={{borderRadius: "10px"}}>
                <img
                  src={story.image}
                  alt={story.title}
                  className="cyber-story-image"
                />
                </div>
                <h3 className="cyber-story-title">
                  <a
                    href={story.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {story.title}
                  </a>
                </h3>
              </div>
            ))}
          </div>
        </Container>
      </section> */}

      <GetInTouch heading="Secure More. Risk Nothing." headingColMd={8} buttonColMd={4}/>
    </div>
  );
};

export default ManagedCybersecurity;
